<template>
    <v-container fluid>
      <FormReport :title="'Relatório de Economia'" 
        :main_headers="main_headers" 
        :secondary_headers="secondary_headers"
        :select_id="catch_id"
        :data_table_prop="data_table" 
        :data_table_expand_prop="data_table_expand"
        :show_expand_prop="show_expand" 
        :onExpand_prop="onExpand"
        :getAlertsPerData="getAlertsPerData"
        :generatePdf="generatePdf"
        :activate_pdf_button="false"
        :calendar_type="'month'"
        :start_view_date="startDatePicker"
        :loading_prop="loading_units"
        >
        
        <template v-slot:summary-header="{ filteredItems }">
          <table style="
            border-radius: 5px;
            border-collapse: collapse;
            width: 100%;
            overflow: hidden;
            height: 85%;
          "
          v-if="data_table && data_table.length > 0"
          >
            <caption class="TitleChecklist" style="background: #0a517f; color: white">
              <strong> Resumo </strong>
            </caption>
            <tr>
              <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
                  Referência: <strong>{{ sumarryFormatedByRows(filteredItems).reference }}</strong>
              </td>
              <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
                  Conta: <strong>{{ sumarryFormatedByRows(filteredItems).account_value }}</strong>
              </td>
              <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
                  Água: <strong>{{ sumarryFormatedByRows(filteredItems).water_liters }}</strong>
              </td>
              <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
                  Esgoto: <strong>{{ sumarryFormatedByRows(filteredItems).sewer_liters }}</strong>
              </td>
              <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
                  Economia ( % ): <strong>{{ sumarryFormatedByRows(filteredItems).economy_percentage }}</strong>
              </td>
              <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
                  Economia ( R$ ): <strong>{{ sumarryFormatedByRows(filteredItems).economy_monetary }}</strong>
              </td>
            </tr>

          </table>
        </template>
        <template v-slot:general-pdf-actions="{ showGeneralButtonPdf, disabledGeneralButtonPdf, generalButtonLoading, generatePdfComponent, generalButtonName }">
          <v-col
            v-if="showGeneralButtonPdf"
            cols="12"
            :sm="last_type_selected === 'client' ? 3 : 2"
            style="margin: 10px 0px 10px 0px;display: flex;justify-content: end;gap: 10px"
          >
            <v-btn :disabled="disabledGeneralButtonPdf" color="primary"
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                font-weight: bold;
                flex: 1;"
              outlined
              @click="generatePdfComponent(null,'general')"
              :loading="generalButtonLoading">
              <v-icon small class="mr-2">
                mdi-file-document-arrow-right-outline
              </v-icon>
              {{ last_type_selected === 'client' ? 'PDF COMPLETO' : generalButtonName }}
            </v-btn>
            <v-btn
              v-if="last_type_selected === 'client'"
              :disabled="disabledGeneralButtonPdf"
              color="primary"
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                font-weight: bold;
                flex: 1;"
              outlined
              @click="generatePdfComponent(null,'general', { includeUnitDetails: false })"
              :loading="generalButtonLoading">
              <v-icon small class="mr-2">
                mdi-file-document-arrow-right-outline
              </v-icon>
              PDF SIMPLES
            </v-btn>
          </v-col>
        </template>
        <template v-slot:button-main-table="{onClick,prop,disabled,loading,status}">
          <v-menu  offset-y >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                style="font-weight: bold"
                outlined       
                :disabled="disabled(prop)"
                :loading="loading(prop)"                     
                
              >
                <v-icon small >
                  mdi-text-box-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list >
                <v-list-item
                  link
                  v-for="(line, index) in getDownloadOptions(prop, status)"
                  :key="index"
                  :value="index"
                  :disabled="isReportOptionDisabled(line, prop)"
                  @click="catch_report_tipe(line,onClick,prop,status)"
                >
                  <v-list-item-title>{{ getReportOptionTitle(line, prop) }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
        </template>
      </FormReport>
      <DialogSendEmail :open="dialog_send_email" :runFunc="sendEmail"/>
    </v-container>
  </template>
  
  <script>
  import ReportScript from "./ReportScript";
  export default ReportScript;
  </script>
  
  <style ></style>
